import PropTypes from 'prop-types'
import React from 'react'
import moment from 'moment'

import styles from './ReserveProgress.scss'

export default class ReserveProgress extends React.Component{
    static propTypes = {
        totalDuration: PropTypes.number,
        endTime: PropTypes.object,
    }
    componentWillMount() {
        this.update()
    }
    update() {
        this.clearTimeouts()
        if (!this.props.endTime) return

        this.timeoutId = setTimeout(this.update.bind(this), 1000)

        this.setState({
            percents: this.getPercents(),
        })
    }
    componentWillUnmount() {
        this.clearTimeouts()
    }
    clearTimeouts() {
        if (this.timeoutId) clearTimeout(this.timeoutId)
    }
    getPercents() {
        const totalDurationMilliseconds = this.props.totalDuration * 1000
        return Math.round(this.props.endTime.diff(moment()) / totalDurationMilliseconds * 100) + '%'
    }
    render() {
        if (!this.props.endTime) return null

        return <div className={styles.base} style={{ height: this.state.percents }} />
    }
}



// WEBPACK FOOTER //
// ./components/ReserveProgress/ReserveProgress.jsx